import { render, staticRenderFns } from "./zBigNumber.vue?vue&type=template&id=5bf6d43a&scoped=true&"
import script from "./zBigNumber.vue?vue&type=script&setup=true&lang=js&"
export * from "./zBigNumber.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6d43a",
  null
  
)

export default component.exports